import { createAction } from '@reduxjs/toolkit';

const FETCHING_GROUP_PERMISSIONS_LIST = 'FETCHING_GROUP_PERMISSIONS_LIST';
const FETCHING_GROUP_PERMISSIONS_LIST_SUCCESS = 'FETCHING_GROUP_PERMISSIONS_LIST_SUCCESS';
const FETCHING_GROUP_PERMISSIONS_LIST_FAILURE = 'FETCHING_GROUP_PERMISSIONS_LIST_FAILURE';
const CREATE_GROUP_PERMISSIONS = 'CREATE_GROUP_PERMISSIONS';
const GET_GROUP_PERMISSIONS_DETAIL = 'GET_GROUP_PERMISSIONS_DETAIL';
const UPDATE_GROUP_PERMISSIONS = 'UPDATE_GROUP_PERMISSIONS';
const CLEAR_GROUP_PERMISSIONS = 'CLEAR_GROUP_PERMISSIONS';
const GROUP_PERMISSIONS_FETCHING_PERMISSIONS_LIST = 'GROUP_PERMISSIONS_FETCHING_PERMISSIONS_LIST';

export interface Permissions {
    id: number;
    name: string;
    codename: string;
}

export interface groupPermissionsListSuccessPayload {
    id?: number | string;
    name: string;
    description?: string;
    code: string;
    status: 0 | 1;
    permissions: Permissions[];
    created_at: string;
    updated_at: string;
}

type groupPermissionsDataDetailType = Omit<
    groupPermissionsListSuccessPayload,
    'id' | 'status' | 'created_at' | 'updated_at' | 'code'
>;

export const fetchingGroupPermissionsList = createAction(FETCHING_GROUP_PERMISSIONS_LIST, (filters: any) => ({
    payload: filters,
}));

export const fetchingGroupPermissionsListSuccess = createAction<
    groupPermissionsListSuccessPayload[]
>(FETCHING_GROUP_PERMISSIONS_LIST_SUCCESS);

export const fetchingGroupPermissionsListFailure = createAction(
    FETCHING_GROUP_PERMISSIONS_LIST_FAILURE,
);

export const createGroupPermissions = createAction<groupPermissionsDataDetailType>(CREATE_GROUP_PERMISSIONS);

export const getGroupPermissionsDetail = createAction(
    GET_GROUP_PERMISSIONS_DETAIL,
    (id: string) => ({
        payload: { id: id },
    }),
);

export const clearGroupPermissions = createAction(CLEAR_GROUP_PERMISSIONS);

export const updateGroupPermissions = createAction<any>(
    UPDATE_GROUP_PERMISSIONS,
    (data: groupPermissionsDataDetailType, id: string) => ({
        payload: { data: data, id: id },
    }),
);

export const fetchPermissionsList = createAction(GROUP_PERMISSIONS_FETCHING_PERMISSIONS_LIST, (page: number | null, page_size: number | null) => ({
    payload: { page: page, page_size: page_size }
}));
